import { generateLoadingToast } from '../_utils';
import { toast } from 'react-toastify';
import { errorHandler } from '../_utils/errorHandlers';

export const verifySocialEmail = async (sdkClientInstance, email: string, hash: string) => {
  const toastId = generateLoadingToast('Email verification in progress');
  sdkClientInstance.verifySocialEmail(email, hash)
  .then(() => toast.success('Email was verified successfully', { className: "custom-toast" }))
  .catch(e =>  errorHandler(e))
  toast.dismiss(toastId);
}
